import { QueryFactory } from "../../../../Common";
import { RC } from "../../../../Contracts";
export const QGetSettings = QueryFactory(RC.QueryTypes.GetSettings);
//# sourceMappingURL=QGetSettings.js.map